export default {"src":"/_next/static/media/facebook-logo.cde94865.svg","height":23,"width":14};